import './InputAutocomplete.scss';

import React from 'react';
import PropTypes from 'prop-types';

class InputAutocomplete extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      resetAfterSelect: this.props.resetAfterSelect === undefined ? false : this.props.resetAfterSelect,
      suggestions: [],
      text: this.props.textDecorator(this.props.item) || ''
    };
    this.loader = null;

    this.handleType = this.handleType.bind(this);
    this.selectSuggestion = this.selectSuggestion.bind(this);
  }

  handleType(event) {
    this.setState({ text: event.target.value }, () => {
      if (this.loader === null) {
        this.loader = setTimeout(() => {
          this.loadSuggestions();
        }, 500);
      }
    });
  }

  loadSuggestions() {
    if (this.state.isLoading) {
      clearTimeout(this.loader);
      this.loader = setTimeout(() => {
        this.loadSuggestions();
      }, 500);
    } else {
      this.setState({ isLoading: true }, () => {
        this.loader = null;

        fetch(`${this.props.url}?query=${encodeURIComponent(this.state.text)}`, {
          credentials: 'same-origin',
          headers: { Accept: 'application.json' },
        })
          .then(function (response) {
            if (response.status >= 200 && response.status < 300) {
              return response.json();
            } else {
              const error = new Error(response.statusText);
              error.response = response;
              throw error;
            }
          })
          .then((data) => {
            this.setState({ isLoading: false, suggestions: data });
          })
          .catch((error) => {
            this.setState({ isUpdating: false });
            alert('Произошла ошибка при загрузке вариантов');
          });
      });
    }
  }

  selectSuggestion(suggestion) {
    this.setState({ suggestions: [], text: this.state.resetAfterSelect ? '' : this.props.textDecorator(suggestion) }, () => {
      this.props.onChange && this.props.onChange(suggestion);
    });
  }

  render() {
    const suggestions = this.state.suggestions.slice(0, 10).map((item) => {
      return (
        <a
          key={item.id === undefined ? item.vin : [item.class, item.id].join('-')}
          className={`dropdown-item ${this.state.isLoading && 'has-text-grey-lighter'}`}
          onClick={() => {
            this.selectSuggestion(item);
          }}
        >
          {this.props.itemDecorator && this.props.itemDecorator(item)}
          {!this.props.itemDecorator && item}
        </a>
      );
    });

    return (
      <div className={`dropdown InputAutocomplete ${this.state.suggestions.length > 0 && 'is-active'}`}>
        <div className="dropdown-trigger">
          <div className={`control ${this.state.isLoading && 'is-loading'}`}>
            <input className={`input ${this.props.classes || ''}`} value={this.state.text} onChange={this.handleType} />
            {this.props.classes == 'is-danger' &&
              <p className="help is-danger">Идентификационный номер (VIN) автомобиля не найден. Укажите, пожалуйста, корректный номер</p>
            }
          </div>
        </div>
        <div className="dropdown-menu">
          <div className="dropdown-content">{suggestions}</div>
        </div>
      </div>
    );
  }
}

InputAutocomplete.propTypes = {
  item: PropTypes.object,
  itemDecorator: PropTypes.func,
  onChange: PropTypes.func,
  resetAfterSelect: PropTypes.bool,
  text: PropTypes.string,
  textDecorator: PropTypes.func,
  classes: PropTypes.string,
  url: PropTypes.string,
};

export default InputAutocomplete;
